import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  forwardRef,
} from 'react';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import SecuredImage from 'modules/common/components/SecuredImage';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import * as actions from '../action';
import * as c from '../constant';
import ViewImage from './ViewImage';

// class ComponentToPrint extends React.Component {
const ComponentToPrint = forwardRef(({ src, rotation, heightWidth }, ref) => {
  const imgSrc = src;
  return (
    <SecuredImage
      ref={ref}
      onContextMenu={e => {
        e.preventDefault();
        return false;
      }}
      alt="BC"
      style={{
        transform: ` rotate(${rotation}deg)`,
        width: `${heightWidth}`,
        height: `${heightWidth}`,
      }}
      src={imgSrc}
    />
    // <embed src={src} title="BC Photo" />
  );
});

ComponentToPrint.propTypes = {
  src: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
  heightWidth: PropTypes.string.isRequired,
};

function FindDeathCertificateModal({
  searchParams,
  getDeathCertificatesArchive,
  deathCertificatesArchiveList,
  isLoading,
  approveTransaction,
  showTransaction,
  id,
  approving,
  isCheckingArchive,
  type,
  startAssessment,
  isAssessing,
  // getPhoto,
  isLoadingPhoto,
  permissions,
}) {
  const [heightWidth, setHeightWidth] = useState('auto');
  const [rotation, setRotation] = useState(0);
  const toPrintContentRef = useRef();
  const setModal = useContext(ModalContext);
  const [imgSrc, setImgSrc] = useState('');
  // const [imgData, setImgData] = useState('');
  const [imgSide, setImgSide] = useState('');
  const [isSearch, setIsSearch] = useState(0);
  const [formData, setFormData] = useState({
    remarks: '',
  });

  useEffect(() => {
    const combine = { ...searchParams, search_by: 'DETAILS' };
    getDeathCertificatesArchive(
      {
        ..._.pick(
          {
            first_name: _.get(combine, 'first_name'),
            last_name: _.get(combine, 'last_name'),
            extension_name: _.get(combine, 'extension_name'),
            death_date: _.get(combine, 'death_date'),
            search_by: _.get(combine, 'search_by'),
          },
          _.keys(c.FORM_DATA)
        ),
      },
      () => {
        setIsSearch(1);
      }
    );
  }, []);

  const onChangeInput = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onApprove = e => {
    e.preventDefault();

    approveTransaction(
      id,
      {
        // remarks: 'You can now generate Reference Number for payment',
        status: 'PENDING',
      },
      () => {
        showTransaction(id);
        setModal({ isOpen: false });
        setFormData({
          remarks: '',
        });
      }
    );
  };

  const onReject = e => {
    e.preventDefault();

    ConfirmAlert(
      'Please input the reason.',
      remarks => {
        approveTransaction(
          id,
          {
            remarks,
            status: 'REJECTED',
          },
          () => {
            showTransaction(id);
            setModal({ isOpen: false });
            setFormData({
              remarks: '',
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const onShowFront = () => {
    setImgSrc('');

    const images = deathCertificatesArchiveList.map(item => {
      return item.images;
    });

    setImgSrc(_.get(images, '0.0.front_page'));
    setImgSide('front');
  };

  const onShowBack = () => {
    setImgSrc('');

    const images = deathCertificatesArchiveList.map(item => {
      return item.images;
    });
    setImgSrc(_.get(images, '0.1.back_page'));
    setImgSide('back');
  };

  const onForAppearance = e => {
    e.preventDefault();

    ConfirmAlert(
      'Please input the reason.',
      remarks => {
        approveTransaction(
          id,
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(id);
            setModal({ isOpen: false });
            setFormData({
              remarks: '',
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const onReceive = (e) => {
  //   e.preventDefault();

  //   startAssessment(id, () => {
  //     approveTransaction(
  //       id,
  //       {
  //         remarks: formData.remarks,
  //         status: 'RECEIVED',
  //       },
  //       () => {
  //         showTransaction(id);
  //         setModal({ isOpen: false });
  //         setFormData({
  //           remarks: '',
  //         });
  //       }
  //     );
  //   });
  // };

  const onPrinted = e => {
    e.preventDefault();

    startAssessment(id, () => {
      approveTransaction(
        id,
        {
          remarks: formData.remarks,
          status: 'PRINTED',
        },
        () => {
          showTransaction(id);
          setModal({ isOpen: false });
          setFormData({
            remarks: '',
          });
        }
      );
    });
  };

  const handleGetPhoto = (data, side) => e => {
    e.preventDefault();
    // setImgData(data);

    setImgSide(side);
    if (side === 'front') {
      setImgSrc(_.get(data, 'front_page'));
    }
    if (side === 'back') {
      setImgSrc(_.get(data, 'back_page'));
    }
  };

  const onBack = e => {
    e.preventDefault();
    setImgSrc('');
  };

  const getTr = item => {
    let listImages = [];
    listImages = item.images;
    return listImages.map((deathDetail, index) => (
      <tr
        // eslint-disable-next-line react/no-array-index-key
        key={`${_.get(item, 'id')}+${index}`}
        className="border-top"
      >
        <td>{`${_.get(item, 'registry_number')}`}</td>
        <td>
          {`${_.get(item, 'first_name')}
            ${_.get(item, 'middle_name') || ''}
            ${_.get(item, 'last_name')}`.toUpperCase()}
        </td>

        <td>{`${moment(_.get(item, 'death_date')).format('MM/DD/YYYY')}`}</td>

        <td style={{ textAlign: 'right' }}>
          <ViewImage
            item={deathDetail}
            isLoading={isLoadingPhoto}
            handleGetPhoto={handleGetPhoto}
          />
        </td>
      </tr>
    ));
  };

  const onRotateLeft = e => {
    e.preventDefault();
    let newRotation = rotation - 90;
    if (newRotation === -360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [-90, 270, 90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };

  const onRotateRight = e => {
    e.preventDefault();
    let newRotation = rotation + 90;
    if (newRotation === 360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [90, 270, -90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      {isCheckingArchive && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      {isSearch === 1 && deathCertificatesArchiveList.length !== 0 && (
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12 mt-3">
                {imgSrc === '' && (
                  <table className="table table-borderless table-striped table-sm table-condensed">
                    <thead>
                      <tr>
                        <th scope="col">Registry Number</th>
                        <th scope="col">Name</th>
                        <th scope="col">Date of Death</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deathCertificatesArchiveList.map(item => getTr(item))}
                    </tbody>
                  </table>
                )}
                {imgSrc !== '' && (
                  <>
                    <div div className="d-flex justify-content-between">
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                          onClick={onBack}
                        >
                          <i className="fa fa-arrow-left" />
                          &nbsp;BACK
                        </button>
                        &nbsp;
                        {Acl(permissions, ['PRINT DEATH CERTIFICATE']) && (
                          <ReactToPrint
                            trigger={() => (
                              <button
                                type="button"
                                className="btn btn-md btn-success"
                              >
                                <i className="fa fa-print" />
                                &nbsp;PRINT
                              </button>
                            )}
                            content={() => toPrintContentRef.current}
                          />
                        )}
                        &nbsp;
                        <button
                          type="button"
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                          onClick={onRotateLeft}
                        >
                          <i className="fa fa-arrow-left" />
                          &nbsp;ROTATE LEFT
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                          onClick={onRotateRight}
                        >
                          ROTATE RIGHT&nbsp;
                          <i className="fa fa-arrow-right" />
                        </button>
                      </div>
                      <div>
                        {imgSide === 'back' ? (
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md mr-2"
                            onClick={onShowFront}
                          >
                            SHOW FRONT
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                            onClick={onShowBack}
                          >
                            SHOW BACK
                          </button>
                        )}
                      </div>
                    </div>
                    &nbsp;
                    <hr />
                    <div className="dc-wrapper d-flex justify-content-center">
                      <ComponentToPrint
                        rotation={rotation}
                        heightWidth={heightWidth}
                        src={imgSrc}
                        ref={toPrintContentRef}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!isCheckingArchive && deathCertificatesArchiveList.length === 0 && (
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> Death Certificate not found </p>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-center">
        {type === 'check' && deathCertificatesArchiveList.length > 0 && (
          <div className="input-group mt-3 col-6">
            {/* <input
            onChange={onChangeInput}
            value={formData.remarks}
            name="remarks"
            type="text"
            className="form-control"
            placeholder="Remarks"
            aria-label="Remarks"
            aria-describedby="basic-addon2"
          /> */}
            <div className="input-group-append">
              &nbsp;
              {deathCertificatesArchiveList.map((data, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={`${data.id}-${i}`}>
                  {data.images.map(
                    (item, index) =>
                      !_.isEmpty(item.front_page) &&
                      !_.isEmpty(item.front_page) &&
                      Acl(permissions, ['APPROVE DEATH CERTIFICATE']) && (
                        <div
                          // eslint-disable-next-line react/no-array-index-key
                          key={`${item.front_page}-${index}`}
                          className="input-group-append"
                        >
                          &nbsp;
                          <button
                            style={{ width: '150px' }}
                            disabled={approving}
                            onClick={onApprove}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                            type="button"
                          >
                            {approving ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              `APPROVE`
                            )}
                          </button>
                        </div>
                      )
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="input-group-append">
              &nbsp;
              {Acl(permissions, ['REJECT DEATH CERTIFICATE']) && (
                <button
                  disabled={approving}
                  style={{ width: '150px' }}
                  onClick={onReject}
                  className="btn btn-danger"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `REJECT`
                  )}
                </button>
              )}
            </div>
            <div className="input-group-append">
              &nbsp;
              {Acl(permissions, ['REJECT DEATH CERTIFICATE']) && (
                <button
                  disabled={approving}
                  style={{ width: '150px' }}
                  onClick={onForAppearance}
                  className="btn btn-warning"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `FOR APPEARANCE`
                  )}
                </button>
              )}
            </div>
          </div>
        )}
        &nbsp;
        {type === 'check' && deathCertificatesArchiveList.length === 0 && (
          <div className="input-group mt-3 col-6">
            <div className="input-group-append">
              &nbsp;
              {Acl(permissions, ['REJECT DEATH CERTIFICATE']) && (
                <button
                  disabled={approving}
                  onClick={onReject}
                  className="btn btn-danger"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `Reject`
                  )}
                </button>
              )}
            </div>
          </div>
        )}
        &nbsp;
        {type === 'view' &&
          deathCertificatesArchiveList.length > 0 &&
          imgSrc === '' && (
            <div className="input-group mt-3 col-6">
              <input
                onChange={onChangeInput}
                value={formData.remarks}
                name="remarks"
                type="text"
                className="form-control"
                placeholder="Remarks"
                aria-label="Remarks"
                aria-describedby="basic-addon2"
              />
              {/* <div className="input-group-append">
                &nbsp;
                {Acl(permissions, ['RECEIVE BIRTH CERTIFICATE']) && (
                  <button
                    disabled={approving || isAssessesing}
                    onClick={onReceive}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    type="button"
                  >
                    {approving || isAssessesing ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      `TAG AS RELEASE`
                    )}
                  </button>
                )}
              </div> */}
              <div className="input-group-append">
                &nbsp;
                {Acl(permissions, ['PRINT DEATH CERTIFICATE']) && (
                  <button
                    disabled={approving || isAssessing}
                    onClick={onPrinted}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    type="button"
                  >
                    {approving || isAssessing ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      `TAG AS PRINTED`
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        &nbsp;
        <button
          disabled={isLoading}
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
      </div>
    </Modal.Body>
  );
}
FindDeathCertificateModal.propTypes = {
  id: PropTypes.string.isRequired,
  searchParams: PropTypes.instanceOf(Object).isRequired,
  deathCertificatesArchiveList: PropTypes.instanceOf(Array).isRequired,
  getDeathCertificatesArchive: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  isCheckingArchive: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  isAssessing: PropTypes.bool.isRequired,
  // getPhoto: PropTypes.instanceOf(Function).isRequired,
  isLoadingPhoto: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  deathCertificatesArchiveList: _.get(api, `${c.GET_DEATH_ARCHIVE}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_DEATH_ARCHIVE) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
  isCheckingArchive: api.loading.indexOf(c.GET_DEATH_ARCHIVE) > -1,
  isAssessing: api.loading.indexOf(c.START_ASSESSMENT) > -1,
  isLoadingPhoto: api.loading.indexOf(c.GET_PHOTO) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(FindDeathCertificateModal);
